export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[560px] lg:max-w-none">
            <div className="relative aspect-[16/10] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20scene%2C%20comfortable%20sofa%20with%20throw%20pillows%2C%20soft%20ambient%20golden%20lighting%2C%20film%20posters%20on%20wall%2C%20popcorn%20bowl%2C%20modern%20minimalist%20living%20room%2C%20warm%20amber%20and%20cream%20tones%2C%20inviting%20atmosphere%2C%20editorial%20interior%20photography&width=1120&height=700&seq=about-66-cinema&orientation=landscape"
                alt="六六影院品牌介绍 - 家庭影院观影体验"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
              关于六六影院
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                六六影院成立于2020年，致力于为广大电影爱好者提供一站式的免费高清在线观影服务。
                我们深知每一位影迷对电影的热爱，因此持续打造海量片库，涵盖动作、科幻、喜剧、
                悬疑、爱情、动画等全类型电影资源。
              </p>
              <p>
                从好莱坞商业大片到独立艺术佳作，从经典老片到最新上映的热门新片，
                六六影院每日更新超过30部影片，确保每一位观众都能找到心仪的作品。
                1080P超清画质搭配智能加速技术，让你在家即可享受影院级的观影体验。
              </p>
              <p>
                未来，六六影院将继续拓展片库规模，优化播放体验，做你最值得信赖的在线观影平台。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 whitespace-nowrap">4年+</div>
                <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">稳定运营</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 whitespace-nowrap">500万+</div>
                <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">月活用户</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 whitespace-nowrap">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">播放成功率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}